var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckBoxOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 4,
    fill: "#B32651"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.29987 11.6999C6.2332 11.6999 6.17209 11.6888 6.11654 11.6666C6.06098 11.6444 6.00543 11.6055 5.94987 11.5499L2.9332 8.53327C2.8332 8.43327 2.7832 8.31105 2.7832 8.1666C2.7832 8.02216 2.8332 7.89993 2.9332 7.79993C3.0332 7.69993 3.14987 7.64993 3.2832 7.64993C3.41654 7.64993 3.5332 7.69993 3.6332 7.79993L6.29987 10.4666L12.3499 4.4166C12.4499 4.3166 12.5693 4.2666 12.7082 4.2666C12.8471 4.2666 12.9665 4.3166 13.0665 4.4166C13.1665 4.5166 13.2165 4.63605 13.2165 4.77493C13.2165 4.91382 13.1665 5.03327 13.0665 5.13327L6.64987 11.5499C6.59431 11.6055 6.53876 11.6444 6.4832 11.6666C6.42765 11.6888 6.36654 11.6999 6.29987 11.6999Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxOn);
export default __webpack_public_path__ + "static/media/checkBoxOn.62e6792b.svg";
export { ForwardRef as ReactComponent };